module.exports = __webpack_public_path__ + "assets/menu.56b54f8c.svg";